import React from 'react';
import PropTypes from 'prop-types';
import { formatText } from 'core/i18n';
import MessagesScreen from 'components/messagesScreen/messagesScreen';
import AbortedView from './AbortedView';

const OfflineView = ({ identityStatus, onCanceledOrAbortedAction, onFinishAction }) => {
    if (identityStatus === 'canceled' || identityStatus === 'aborted') {
        onCanceledOrAbortedAction();
        return (
            <div className="identity-verification-views">
                <AbortedView />
            </div>
        );
    }

    return (
        <div className="identity-verification-views">
            <div className="main-container messages-main-container basic-layering">
                <MessagesScreen
                    iconClass="icons icons--icon-checked"
                    title={formatText('messagesScreen-videoCallFinishTitle')}
                    buttonText={formatText('button-continue')}
                    showRoadmapNavigation={true}
                    roadmapNavigationProps={{
                        buttonContinueAction: onFinishAction,
                    }}
                />
            </div>
        </div>
    );
};

OfflineView.propTypes = {
    identityStatus: PropTypes.string.isRequired,
    onCanceledOrAbortedAction: PropTypes.func.isRequired,
    onFinishAction: PropTypes.func.isRequired,
};

export default OfflineView;
